import { useQuery } from "@tanstack/react-query";
import { trainingMonthlyPlanApi } from "../../../../../services/human-organization/training-course-monthly.service";
import { useRequests } from "../../../../../hook";
import { useMemo } from "react";

const users = [
  "thiennv@viags.vn",
  "namdh@viags.vn",
  "trungdt@viags.vn",
  "hieppt@viags.vn",
  "botit@viags.vn",
  "tienhc@viags.vn",
  "huyth@viags.vn",
  "datnt@viags.vn",
  "sonnhong@viags.vn",
  "taidv@viags.vn",
  "thuonghh@viags.vn",
  "luubd@viags.vn",
  "nghitc@viags.vn",
  "phuocvd@viags.vn",
];

const selectHandler = ({ value }: any) => {
  const mappedRequests = value.map(trainingMonthlyPlanApi.toResponse);
  return mappedRequests.reverse();
};

export const useMTPRequests = () => {
  const { getRequests, getMyRequests } = useRequests();

  const query = useQuery<any>({
    queryKey: ["MTP-requests"],
    queryFn: () => trainingMonthlyPlanApi.getRequests(),
    select: selectHandler,
  });

  const requests: any[] = useMemo(
    () => getRequests(query?.data, users),
    [getRequests, query?.data]
  );

  const myRequests = useMemo(
    () => getMyRequests(query?.data),
    [getMyRequests, query?.data]
  );

  return { ...query, myRequests, requests };
};
